module.exports = __webpack_public_path__ + "img/ru.0f10f986.jpg";